import React, { useState, useRef, useEffect } from 'react'

import { Carousel as CarouselComp } from 'react-responsive-carousel'
import styled from 'styled-components'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import {
    VideoModal,
} from '../../'
import { useEventListener } from '../../../_helpers'
import {
    UpperHeader,
    devices,
    Container,
    colors,
    CarouselNext,
    CarouselPrev,
} from '../../Common'


export const SimpleCarousel = ({ slides, smallTitle, dots, captions, clickSlide }) => {
    const [activeSlide, setActiveSlide] = useState(clickSlide)
    const [videoModal, setVideoModal] = useState(false)
    const [videoUrl, setVideoUrl] = useState('')
    const [height, setHeight] = useState('')
    // const [carouselWidth, setCarouselWidth] = useState(parentWidth)
    const carousel = useRef()

    const handleChange = id => setActiveSlide(id)

    const openVideoModal = video_url => {
        setVideoModal(true)
        setVideoUrl(video_url)
    }

    const closeVideoModal = () => setVideoModal(false)

    const next = () => setActiveSlide(activeSlide + 1)
    const prev = () => setActiveSlide(activeSlide - 1)

    const updateDimensions = () => {
        const ratio = 898 / 1469
        const width = carousel.current.offsetWidth
        // setCarouselWidth(width)
        setHeight(ratio * width)
    }

    useEffect(() => {
        updateDimensions()
    }, [])

    useEventListener('resize', updateDimensions)

    return (
        <CarouselContainer ref={carousel}>
            {smallTitle ? <UpperHeader marginbottom='10'>{smallTitle}</UpperHeader> : ''}
            <CarouselFlex>
                <CarouselPrev onClick={prev} role='button' aria-label='Previous slide' />
                <StyledCarousel
                    height={height}
                    showStatus={false}
                    showArrows={false}
                    showThumbs={false}
                    showIndicators={false}
                    infiniteLoop={slides.length > 1}
                    stopOnHover={false}
                    interval={5000}
                    transitionTime={500}
                    autoPlay={false}
                    selectedItem={activeSlide}
                    onChange={handleChange}
                    // carouselwidth={carouselWidth}
                >

                    {slides.map(img =>
                        <div key={img.image}>
                            {img.image ? (
                                <SlideImageCard
                                    height={height}
                                    background={img.image}
                                    // orientation={img.orientation === 'portrait' ? 'contain' : 'cover'}
                                    alt={img.alt_text}
                                />
                            ) : ''}
                            {img.video_url ? (
                                <VideoThumbnail image={img.video_thumbnail || img.youtube_thumbnail || img.vimeo_thumbnail} alt={img.alt_text} height={height}>
                                    <VideoPlayButton onClick={() => openVideoModal(img.video_url)} />
                                </VideoThumbnail>
                            ) : ''}
                            {img.caption && captions ? (
                                <Caption>{img.caption}</Caption>
                            ) : ''}
                        </div>
                    )}
                </StyledCarousel>
                <CarouselNext onClick={next} role='button' aria-label='Next slide' />
            </CarouselFlex>
            {/* {slides && slides.length > 1 && dots ? (
                <Dots captions={captions}>
                    {slides.map((slide, i) =>
                        <Dot
                            key={i.toString()}
                            onClick={() => setActiveSlide(i)}
                            active={i === activeSlide}
                            role='button'
                            aria-label={`Hero Carousel Image ${i}`}
                        />
                    )}
                </Dots>
            ) : ''} */}
            <VideoModal
                url={videoUrl}
                videoModal={videoModal}
                closeVideoModal={closeVideoModal} />
        </CarouselContainer>
    )
}

const CarouselContainer = styled.div`
    margin-bottom: 30px;
    position: relative;

    @media ${devices.small} {
        margin-bottom: 20px;
    }
`

const StyledCarousel = styled(CarouselComp)`
    flex: 1 0 33%;

    .slide {
        background: transparent;
        @media ${devices.small} {
            height: 210px;
        }
    }

    && {
        .control-dots {
            display: none;
        }
    }
`

export const VideoThumbnail = styled.div`
    height: ${({ height }) => height}px;
    background: url(${({ image }) => image});
    background-position: center;
    background-size: cover;
    cursor: pointer;
    // margin-bottom: 30px;

    @media ${devices.small} {
        height: 210px;
    }
`

export const VideoPlayButton = styled.div`
    height: 55px;
    width: 47px;
    background: url(/static/images/sprite.svg) -1px -570px;
    cursor: pointer;
`

const ImageCard = styled.div`
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background: url(${props => props.background}) no-repeat 50% 50%/cover;
`

const SlideImageCard = styled(ImageCard)`
    margin-bottom: 0;
    background-position: top;
    border: 10px solid white;
    @media ${devices.small} {
        height: 210px;
    }
`

const CarouselFlex = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    @media ${devices.mobile} {
        margin-bottom: ${({ lightbox }) => lightbox ? '20' : '0'}px;
    }
`

// const Dots = styled.div`
//     margin-top: ${props => props.captions ? '0' : '20px'};
//     width: 100%;
//     text-align: ${props => props.captions ? 'right' : 'center'};
//     z-index: 100;

//     ${props => props.captions && `
//         position: absolute;
//         bottom: 0;
//     `}

//     @media ${devices.small} {
//         ${Container} {
//             padding-bottom: 0;
//         }
//     }
// `

// const Dot = styled.div`
//     display: inline-block;
//     width: 16px;
//     height: 16px;
//     border-radius: 16px;
//     border: 1px solid ${colors.darkGreen};
//     background: ${({ active }) => active ? colors.yellow : 'transparent'};
//     margin-right: 17px;
//     cursor: pointer;

//     &:last-child {
//         margin-right: 0;
//     }

//     @media ${devices.small} {
//         margin-bottom: 10px;
//     }
// `

const Caption = styled.div`
    text-align: left;
    margin-top: 10px;
    width: fit-content;
`
